module.exports = __webpack_public_path__ + "img/GAME_AIRPLANE2.5ca6775c.jpg";